import { IMG } from "@/config/site";

// MBGA Genesis Collection — 12 conceptual collectibles.
// Images: curated cinematic photography where it fits; original SVG motifs otherwise.
// No invented supply, rarity percentages or sales data: rarities are PROPOSED tiers,
// every item status reflects the real pre-launch state.

export const NFTS = [
  {
    slug: "genesis-gold",
    id: "MBGA-001",
    name: "MBGA Genesis Gold",
    collection: "genesis",
    rarity: "legendary",
    status: "coming_soon",
    image: IMG.goldLens,
    motif: null,
    desc: {
      en: "The official golden coin of the MAGABRAZIL universe — the founding artifact of the Genesis collection.",
      pt: "A moeda dourada oficial do universo MAGABRAZIL — o artefato fundador da coleção Genesis.",
    },
  },
  {
    slug: "brazilian-eagle",
    id: "MBGA-002",
    name: "MBGA Brazilian Eagle",
    collection: "genesis",
    rarity: "epic",
    status: "coming_soon",
    image: IMG.palmForest,
    motif: null,
    desc: {
      en: "A stylized eagle over the Atlantic rainforest, rendered in deep green and metallic gold.",
      pt: "Uma águia estilizada sobre a mata atlântica, em verde profundo e ouro metálico.",
    },
  },
  {
    slug: "cyber-jaguar",
    id: "MBGA-003",
    name: "MBGA Cyber Jaguar",
    collection: "collectibles",
    rarity: "epic",
    status: "coming_soon",
    image: IMG.neonLeaves,
    motif: null,
    desc: {
      en: "The Brazilian jaguar reimagined as a futuristic neon guardian of the ecosystem.",
      pt: "A onça brasileira reimaginada como guardiã futurista em neon do ecossistema.",
    },
  },
  {
    slug: "golden-bull",
    id: "MBGA-004",
    name: "MBGA Golden Bull",
    collection: "gold",
    rarity: "rare",
    status: "coming_soon",
    image: null,
    motif: "bull",
    desc: {
      en: "A digital golden bull charging through candlelight — pure market energy, Brazilian style.",
      pt: "Um touro dourado digital em plena carga — energia de mercado pura, em estilo brasileiro.",
    },
  },
  {
    slug: "guardian-shield",
    id: "MBGA-005",
    name: "MBGA Guardian Shield",
    collection: "collectibles",
    rarity: "rare",
    status: "coming_soon",
    image: null,
    motif: "shield",
    desc: {
      en: "A technological shield honoring transparency, security and on-chain verification.",
      pt: "Um escudo tecnológico em homenagem à transparência, segurança e verificação on-chain.",
    },
  },
  {
    slug: "emerald-rocket",
    id: "MBGA-006",
    name: "MBGA Emerald Rocket",
    collection: "collectibles",
    rarity: "rare",
    status: "coming_soon",
    image: IMG.palmClose,
    motif: null,
    desc: {
      en: "The green-and-gold rocket of the community — a tribute to every Brazilian builder.",
      pt: "O foguete verde e dourado da comunidade — um tributo a cada builder brasileiro.",
    },
  },
  {
    slug: "diamond-coin",
    id: "MBGA-007",
    name: "MBGA Diamond Coin",
    collection: "gold",
    rarity: "epic",
    status: "coming_soon",
    image: IMG.glassStack,
    motif: null,
    desc: {
      en: "A crystal-layered coin for the diamond-handed believers of the Genesis era.",
      pt: "Uma moeda em camadas de cristal para os holders de mãos de diamante da era Genesis.",
    },
  },
  {
    slug: "solana-pioneer",
    id: "MBGA-008",
    name: "MBGA Solana Pioneer",
    collection: "collectibles",
    rarity: "rare",
    status: "coming_soon",
    image: null,
    motif: "pioneer",
    desc: {
      en: "An explorer of the blockchain frontier, mapped block by block on Solana.",
      pt: "Um explorador da fronteira blockchain, mapeado bloco a bloco na Solana.",
    },
  },
  {
    slug: "neon-brazil",
    id: "MBGA-009",
    name: "MBGA Neon Brazil",
    collection: "genesis",
    rarity: "epic",
    status: "coming_soon",
    image: null,
    motif: "map",
    desc: {
      en: "The map of Brazil redrawn in neon circuits — culture as living infrastructure.",
      pt: "O mapa do Brasil redesenhado em circuitos de neon — cultura como infraestrutura viva.",
    },
  },
  {
    slug: "royal-capybara",
    id: "MBGA-010",
    name: "MBGA Royal Capybara",
    collection: "collectibles",
    rarity: "legendary",
    status: "coming_soon",
    image: null,
    motif: "capybara",
    desc: {
      en: "The crowned capybara — Brazil's most beloved icon, minted in premium gold.",
      pt: "A capivara coroada — o ícone mais querido do Brasil, em ouro premium.",
    },
  },
  {
    slug: "golden-vault",
    id: "MBGA-011",
    name: "MBGA Golden Vault",
    collection: "gold",
    rarity: "rare",
    status: "coming_soon",
    image: null,
    motif: "vault",
    desc: {
      en: "The digital vault symbolizing verifiable treasury and locked allocations.",
      pt: "O cofre digital que simboliza tesouraria verificável e alocações bloqueadas.",
    },
  },
  {
    slug: "legendary-genesis",
    id: "MBGA-012",
    name: "MBGA Legendary Genesis",
    collection: "genesis",
    rarity: "legendary",
    status: "coming_soon",
    image: IMG.goldSkull,
    motif: null,
    desc: {
      en: "The special commemorative artwork of the Genesis drop — the crown jewel of MBGA.",
      pt: "A arte comemorativa especial do drop Genesis — a joia da coroa do MBGA.",
    },
  },
];

export const RARITY_ORDER = { legendary: 3, epic: 2, rare: 1 };
